/* CHALURE pagrindinis v2:
   1) „Į krepšelį“ per /cart/add.js ir Prestige krepšelio stalčių, kaip raudonis-v2 (rdv2.js); be JS veikia forma.
   2) Simptomų skirtukai (klaviatūra rodyklėmis); telefone pasirinktas skydelis atslenka į matomą vietą.
   3) Video be garso groja tik matomi; palietus video sustabdomas ar vėl paleidžiamas (be matomų ikonų).
   Failą įtraukia kiekviena ch-* sekcija, todėl paleidžiama tik pirmą kartą (visos sekcijos jau DOM'e, nes defer). */
(() => {
  if (window.chomeReady) return
  window.chomeReady = true
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'

  // Prestige krepšelio stalčius per jo atidarymo mygtuką; jei jo nėra, /cart.
  function openCart() {
    const drawer = document.getElementById('sidebar-cart')
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') return
    const openers = [...document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-cart"], [data-action="open-drawer"][aria-controls="sidebar-cart"]')]
    const opener = openers.find((el) => el.offsetParent !== null) || openers[0]
    if (opener) opener.click()
    else window.location.href = `${root()}cart`
  }

  document.querySelectorAll('.chome form.ch-cart').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!window.fetch) return
      e.preventDefault()
      const btn = form.querySelector('button')
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return
      const label = btn.innerHTML
      btn.disabled = true
      btn.setAttribute('aria-busy', 'true')
      btn.textContent = 'Dedama…'
      const id = Number(form.querySelector('[name="id"]').value)
      const unlock = () => { btn.disabled = false; btn.removeAttribute('aria-busy') }
      fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      })
        .then((r) => { if (!r.ok) throw new Error(`cart/add ${r.status}`) })
        .then(() => {
          btn.innerHTML = label
          unlock()
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: { id }, quantity: 1 } }))
          setTimeout(openCart, 350)
        }, () => {
          btn.textContent = 'Nepavyko. Bandyk dar kartą'
          unlock()
          setTimeout(() => { btn.innerHTML = label }, 2500)
        })
    })
  })

  document.querySelectorAll('.chome .ch-pick__chips').forEach((list) => {
    const tabs = [...list.querySelectorAll('[role="tab"]')]
    const show = (t, fromClick) => {
      let panel
      tabs.forEach((x) => {
        const on = x === t
        x.setAttribute('aria-selected', String(on))
        x.tabIndex = on ? 0 : -1
        const p = document.getElementById(x.getAttribute('aria-controls'))
        if (p) p.hidden = !on
        if (on) panel = p
      })
      if (fromClick && panel && window.innerWidth < 990) panel.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' })
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(t, true))
      t.addEventListener('keydown', (e) => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]
        if (!d) return
        e.preventDefault()
        const n = tabs[(i + d + tabs.length) % tabs.length]
        show(n, false)
        n.focus()
      })
    })
  })

  const cards = [...document.querySelectorAll('.chome .ch-ugc__card')]
  const load = (v) => { if (!v.src) v.src = v.dataset.src }
  cards.forEach((card) => {
    const v = card.querySelector('video')
    const btn = card.querySelector('.ch-ugc__toggle')
    if (!v || !btn) return
    btn.addEventListener('click', () => {
      load(v)
      if (v.paused) {
        delete card.dataset.userPaused
        v.play().catch(() => {})
      } else {
        card.dataset.userPaused = ''
        v.pause()
      }
    })
    v.addEventListener('play', () => btn.setAttribute('aria-pressed', 'true'))
    v.addEventListener('pause', () => btn.setAttribute('aria-pressed', 'false'))
  })
  if (!cards.length || !('IntersectionObserver' in window) || still) return
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    const card = e.target
    const v = card.querySelector('video')
    if (e.isIntersecting && !('userPaused' in card.dataset)) {
      load(v)
      v.play().catch(() => {})
    } else {
      v.pause()
    }
  }), { threshold: 0.5 })
  cards.forEach((c) => io.observe(c))
})()
